module.exports = __webpack_public_path__ + "img/final-reward.527cdf2f.jpg";